<template>
  <div class="transition-global">
    <div class="totemBG tw-bg-cover tw-w-full tw-h-screen customGrid">
      <div class="tw-text-center tw-z-20">
        <vLogoDefault />
      </div>
      <div class="tw-grid" style="grid-template-rows: 1fr auto">
        <div>
          <div
            class="titulo-min-height tw-font-bold tw-text-5xl tw-text-white tw-flex tw-justify-center tw-items-end tw-text-center tw-mb-5"
          >
            <div>Como deseja enviar suas fotos?</div>
          </div>
          <div
            class="tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-start tw-place-items-start"
          >
            <div
              class="tw-w-full tw-flex-none"
              v-for="(item, index) in getListaModos"
              :key="index"
            >
              <div
                class="cardItem tw-mx-auto tw-p-6 tw-w-full tw-cursor-pointer"
                :class="{
                  [item.customCSS]: true,
                  'tw-mt-10 tw-mb-6': index === 0,
                  'tw-mt-4 tw-mb-6': index === 1,
                }"
                @click="selectMode(item.id)"
              >
                <img
                  draggable="false"
                  @contextmenu.prevent
                  @dragstart.prevent
                  class="cardImagem"
                  :src="item.imagem"
                />
                <div class="tw-text-white tw-mt-8">
                  <div class="tw-text-3xl tw-font-bold">
                    {{ item.nome }}
                  </div>
                  <div class="tw-text-3xl tw-font-normal tw-mt-3">
                    {{ item.descricao }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="spacefloat" class="spacefloat-height"></div>
      </div>
    </div>
    <vFloatGuide destinoBack="QTDE_FOTO" :next="false" />
    <!--  -->
    <vTimeout :segundos="$root.getTimeoutName('MODO_CAPTURA')" />
  </div>
</template>

<script>
import vFloatGuide from "@/components/floatGuide.vue";
import etapa from "@/constants/etapaCompra";
import { setEtapaCompra } from "@/service/firebase";
import anime from "animejs/lib/anime.es.js";
import posthog from "@/posthog";

export default {
  components: {
    vFloatGuide,
  },
  data() {
    return {
      listaDeModos: [
        {
          id: "upload",
          nome: "Galeria",
          descricao: "Envie suas fotos pelo celular",
          imagem: require("@/assets/galeria.png"),
          customCSS: "cardGradient2",
        },
        {
          id: "selfie",
          nome: "Selfie",
          descricao: "Tire suas fotos diretamente do totem",
          imagem: require("@/assets/pexels-pixabay-220938.jpg"),
          customCSS: "cardGradient1",
        },
      ],
    };
  },
  mounted() {
    this.animaMounted();
  },
  computed: {
    getListaModos() {
      return this.listaDeModos;
    },
  },
  methods: {
    selectMode(mode) {
      posthog.capture("capture_mode_selected", { capture_mode: mode });
      // Salvar o modo de captura na compra (Vuex + Firestore)
      const compra = this.$store.getters["compra/getCompra"];
      compra.modo_captura = mode;
      this.$store.commit("compra/setCompra", compra);

      const proxima = mode === "selfie" ? etapa.SELFIE : etapa.SCAN_QR_CODE;
      setEtapaCompra(proxima).catch((err) => {
        console.error("Erro ao avançar para envio das fotos:", err);
        this.$root.goto(mode === "selfie" ? "/cabine/selfie" : "/cabine/scan-qr-code");
      });
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customGrid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
}
.transition-global {
  opacity: 0;
}
.titulo-min-height {
  min-height: clamp(4rem, 6vh, 6.25rem);
}
.spacefloat-height {
  height: clamp(8rem, 12vh, 11.25rem);
}
.cardItem {
  box-shadow: 0 0.5rem 0.5rem rgba(140, 38, 101, 0.4);
  border-radius: 0.5rem;
  width: 90%;
  max-width: 56.25rem;
  image-rendering: optimizeQuality;
  text-rendering: optimizeLegibility;

  &.cardGradient1 {
    background: linear-gradient(180deg, #8876a1 0%, #222129 100%);
  }

  &.cardGradient2 {
    background: linear-gradient(180deg, #985d8f 0%, #1a191c 100%);
  }
  .cardImagem {
    width: clamp(11rem, 14vw, 15rem);
    height: clamp(7rem, 9vw, 10rem);
    object-fit: cover;
    border-radius: 0.5rem;
    image-rendering: optimizeQuality;
    @apply tw-mx-auto;
  }
  .cardDescricao {
    @apply tw-text-white;
  }
}
.totemBG {
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
  background-size: cover;
}
</style>
